<template>
  <div>
    <!-- 테이블 표시 제목입니다. -->
    <span v-if="showItemCount">
      {{ title }} ({{ innerItems.length }})
    </span>
    <span v-else>
      {{ title }}
    </span>
    <!-- 테이블 영역 -->
    <div class="table-wrap mt-1">
      <table class="flex-fill table-style">
<!--        <thead>-->
<!--          <tr>-->
<!--            <th style="width: 40px">-->
<!--              {{ 'Id' | translate }}-->
<!--            </th>-->
<!--            <th>-->
<!--              {{ '임대업체 명' | translate }}-->
<!--            </th>-->
<!--          </tr>-->
<!--        </thead>-->
        <tbody>
          <tr v-for="item in innerItems" :key="'td-'+item.rentalcompanyId"
              :class="item.selected ? 'selected-row' : undefined"
              class="table-row"
              @click="onRowClick(item)"
          >
            <td :title="item.rentalcompanyName">
              ({{ item.rentalcompanyId }}) {{ item.rentalcompanyName }}
            </td>
<!--            <td :title="item.rentalcompanyName" >-->
<!--              {{ item.rentalcompanyName }}-->
<!--            </td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {cloneDeep} from "lodash";

export default {
  name: "RentalCompanyList",

  props: {
    // 제목
    title: {
      type: String,
      default: undefined,
    },
    // 목록 아이템
    items:{
      type: Array,
      default:()=>([]),
    },
    // 선택된 아이템들
    selectedItems:{
      type: Array,
      default:()=>([]),
    },
    // 목록 갯수 표시 여부
    showItemCount:{
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      innerItems: [],
      innerSelectedItems: [],
    }
  },

  watch: {
    items:{
      immediate:true,
      deep:true,
      handler(newValue){
        this.innerItems = cloneDeep(newValue)
            .map( m => {
              return {...m, selected:false}
            })
      }
    },
    selectedItems:{
      immediate:true,
      deep:true,
      handler(newValue){
        this.innerSelectedItems = newValue
      }
    },
    innerSelectedItems:{
      immediate: true,
      deep: true,
      handler(newValue){
        // 변경 이벤트 에밋
        this.$emit('update:selectedItems', newValue)
      }
    },
  },

  methods: {
    /**
     * 행 클릭 이벤트 (항목 선택, 선택 취소)
     * @param item 행 아이템
     */
    onRowClick(item) {
      item.selected = !item.selected

      if(item.selected) {
        // 선택 목록에 추가
        this.innerSelectedItems.push(item)
      }else{
        // 선택 목록에서 제외
        const index = this.innerSelectedItems.indexOf(item)
        this.innerSelectedItems.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.table-style{
  border: 1px solid #9e9e9e;
  /*padding: 5px;*/
  height: 100%;
  min-width: 200px;
}

.table-style tbody{
  border: 1px solid #9e9e9e;
  /*padding: 5px;*/
  width: auto;
  max-height: 200px;
  overflow: hidden;
}

.table-style td{
  /*background-color: #0C98FE;*/
  /*border: 1px solid #ff0000;*/
  text-align: left;
  cursor: pointer;
  height: 20px;
  line-height: 20px;
  width: 210px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  display: block;
}

.table-row{
  /*border: 1px solid #ff0000;*/
  /*width: 100%;*/
  /*line-height: 20px;*/
  height: auto;
  display: flex;
  padding: 1px;
}

.selected-row{
  background-color: #e3eef9;
  color: #1976d2;
  /*line-height: 20px;*/
  /*height: auto;*/
  /*min-width: 200px;*/
  /*display: block;*/
  /*padding: 1px;*/
  /*width: 100%;*/
}

.table-wrap{
  border: 1px solid #9e9e9e;
  height: 200px;
  min-width: 200px;
  overflow-y: scroll;
}
</style>
